import { getInlineLoader } from "../Helpers";

export default function MainLoader(props) {

  

  return (
    <div 
      className="MainLoader mSupportLoading"
    >
      {getInlineLoader()}
    </div>
  )
}
